var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgPipelineActive(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 24,
    height: 24,
    viewBox: "0 0 24 24",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M19.2 3H14.7C14.2228 3.00052 13.7653 3.1813 13.4278 3.50268C13.0904 3.82406 12.9005 4.25979 12.9 4.71429V15C12.9005 15.4545 13.0904 15.8902 13.4278 16.2116C13.7653 16.533 14.2228 16.7138 14.7 16.7143H19.2C19.6772 16.7138 20.1347 16.533 20.4722 16.2116C20.8096 15.8902 20.9995 15.4545 21 15V4.71429C20.9995 4.25979 20.8096 3.82406 20.4722 3.50268C20.1347 3.1813 19.6772 3.00052 19.2 3ZM9.3 3H4.8C4.32278 3.00052 3.86526 3.1813 3.52781 3.50268C3.19036 3.82406 3.00055 4.25979 3 4.71429V19.2857C3.00055 19.7402 3.19036 20.1759 3.52781 20.4973C3.86526 20.8187 4.32278 20.9995 4.8 21H9.3C9.77722 20.9995 10.2347 20.8187 10.5722 20.4973C10.9096 20.1759 11.0995 19.7402 11.1 19.2857V4.71429C11.0995 4.25979 10.9096 3.82406 10.5722 3.50268C10.2347 3.1813 9.77722 3.00052 9.3 3Z",
    fill: "#2463AE"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgPipelineActive);
export default __webpack_public_path__ + "static/media/Pipeline-active.ccd874eb6d3ec2b9f7efe5f1c2b385f6.svg";
export { ForwardRef as ReactComponent };